import classNames from 'classnames'
import React, { useState } from 'react'
import { twMerge } from 'tailwind-merge'

interface TextareaProps {
	name?: string
	id?: string
	placeholder?: string
	isValid?: boolean
	className?: string
	onChange?: (event: React.ChangeEvent<HTMLTextAreaElement>) => void
	minimalCharacters?: number
	onMinLenght?: ({ isDisabled }: { isDisabled: boolean }) => void
	value?: string
	rows?: number
	disabled?: boolean
}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
	(
		{
			id,
			placeholder,
			isValid,
			name,
			onChange,
			onMinLenght,
			minimalCharacters,
			rows,
			value,
			disabled,
			className,
			...props
		},
		ref
	) => {
		const [valueInInput, setValueInInput] = useState<number>()

		return (
			<div className='relative w-full'>
				<textarea
					onChange={(e) => {
						if (minimalCharacters) {
							onMinLenght?.({
								isDisabled: e.target.value.length < minimalCharacters,
							})
							setValueInInput(e.target.value.length)
						}
						onChange?.(e)
					}}
					ref={ref}
					id='sidebar-content'
					name={name}
					value={value}
					rows={rows}
					disabled={disabled}
					className={twMerge(
						'bg-transparent border dark:border-white/20 border-opacity-40 border-[#8493ac] rounded-md mb-4 px-[15px] placeholder:text-base dark:placeholder:opacity-40 dark:focus:border-white/40 focus:border-gray-500/40 py-[15px] text-sm text-white opacity-100 w-full outline-none transition-shadow transition-border duration-400 ease-in-out relative disabled:pointer-events-none appearance-none disabled:bg-none disabled:shadow-none',
						classNames(className, {
							'border-red-500/80 dark:border-red-500/80 text-red-500 dark:text-red-500 placeholder:text-red-500 dark:placeholder:text-red-500':
								!isValid && isValid !== undefined,
							'text-opacity-40 bg-opacity-20': disabled,
						})
					)}
					placeholder={placeholder}
					{...props}
				/>

				{minimalCharacters && (
					<span className='text-[14px] font-medium text-white/70 leading-[115%] absolute bottom-0 lg:bottom-7 right-3'>
						{valueInInput && valueInInput > 0
							? `${valueInInput} caracteres (mínimo ${minimalCharacters} caracteres)`
							: `Mínimo ${minimalCharacters} caracteres`}
					</span>
				)}
			</div>
		)
	}
)

export default Textarea
